import React from 'react';

function ContactPage() {
    return (
        <div className="contact-page">
            <h1>Contact Us</h1>
            <section className="datenschutz">
                <h2>Datenschutz</h2>
                <p>Your privacy is important to us. Here's how we protect your data...</p>
            </section>
            <section className="impressum">
                <h2>Impressum</h2>
                <p>Company Information...</p>
            </section>
        </div>
    );
}

export default ContactPage;
